// extracted by mini-css-extract-plugin
export default {"colors":"EditColorV2_colors__ax6D6","advanced":"EditColorV2_advanced__tZkaD","displayNoneShowInDevToolsIfNeeded":"EditColorV2_displayNoneShowInDevToolsIfNeeded__arYok"};